import { render, staticRenderFns } from "./ResearchProjects.vue?vue&type=template&id=bfaf16b2"
import script from "./ResearchProjects.vue?vue&type=script&lang=js"
export * from "./ResearchProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports